var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWow = function SvgWow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5245_18118)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#D67504",
    strokeOpacity: 0.27,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_5245_18118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 22.5C20.5 26.0899 18.4853 28 16 28C13.5147 28 11.5 26.0899 11.5 22.5C11.5 18.9101 13.5147 15 16 15C18.4853 15 20.5 18.9101 20.5 22.5Z",
    fill: "#EB5D3E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5245_18118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 6L11.5904 7.1786C12.0738 8.14355 12.8564 8.92619 13.8214 9.40958L15 10L13.8214 10.5904C12.8564 11.0738 12.0738 11.8564 11.5904 12.8214L11 14L10.4096 12.8214C9.92619 11.8564 9.14355 11.0738 8.1786 10.5904L7 10L8.1786 9.40958C9.14355 8.92619 9.92619 8.14355 10.4096 7.1786L11 6Z",
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5245_18118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 6L21.5904 7.1786C22.0738 8.14355 22.8564 8.92619 23.8214 9.40958L25 10L23.8214 10.5904C22.8564 11.0738 22.0738 11.8564 21.5904 12.8214L21 14L20.4096 12.8214C19.9262 11.8564 19.1436 11.0738 18.1786 10.5904L17 10L18.1786 9.40958C19.1436 8.92619 19.9262 8.14355 20.4096 7.1786L21 6Z",
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 14V14C27.825 14.6488 28.3512 15.175 29 15.5V15.5V15.5C28.3512 15.825 27.825 16.3512 27.5 17V17V17C27.175 16.3512 26.6488 15.825 26 15.5V15.5V15.5C26.6488 15.175 27.175 14.6488 27.5 14V14Z",
    fill: "#85EDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 14V14C6.82501 14.6488 7.35122 15.175 8 15.5V15.5V15.5C7.35122 15.825 6.82501 16.3512 6.5 17V17V17C6.17499 16.3512 5.64878 15.825 5 15.5V15.5V15.5C5.64878 15.175 6.17499 14.6488 6.5 14V14Z",
    fill: "#85EDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3V3C7.82501 3.64878 8.35122 4.17499 9 4.5V4.5V4.5C8.35122 4.82501 7.82501 5.35122 7.5 6V6V6C7.17499 5.35122 6.64878 4.82501 6 4.5V4.5V4.5C6.64878 4.17499 7.17499 3.64878 7.5 3V3Z",
    fill: "#85EDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11V11C1.82501 11.6488 2.35122 12.175 3 12.5V12.5V12.5C2.35122 12.825 1.82501 13.3512 1.5 14V14V14C1.17499 13.3512 0.648785 12.825 0 12.5V12.5V12.5C0.648785 12.175 1.17499 11.6488 1.5 11V11Z",
    fill: "#85EDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 3V3C20.825 3.64878 21.3512 4.17499 22 4.5V4.5V4.5C21.3512 4.82501 20.825 5.35122 20.5 6V6V6C20.175 5.35122 19.6488 4.82501 19 4.5V4.5V4.5C19.6488 4.17499 20.175 3.64878 20.5 3V3Z",
    fill: "#85EDED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_5245_18118",
    x: 10.5,
    y: 15,
    width: 11,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5245_18118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5245_18118",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5245_18118"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5245_18118",
    x: 5,
    y: 4,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.570833 0 0 0 0 0.292552 0 0 0 0 0.0356771 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5245_18118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5245_18118",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5245_18118",
    x: 15,
    y: 4,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.570833 0 0 0 0 0.292552 0 0 0 0 0.0356771 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5245_18118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5245_18118",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5245_18118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16) rotate(90) scale(32)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EED919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BE08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5245_18118",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5245_18118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wow.29bc8869.svg";
export { ForwardRef as ReactComponent };